import styled from "styled-components";

export const SubDepartmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding: 24px 24px 0 24px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 auto;
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderDescription = styled.div`
  display: flex;
  align-items: center;
`;

export const CountText = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const CardContent = styled.div`
  padding: 24px;
  width: 100%;
`;

export const SubDepartmentsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const EmptyStateContainer = styled.div`
  width: 100%;
  min-height: 200px;
  border-radius: 8px;
  border: 2px dashed ${(props) => props.theme.colors.border};
  background: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

export const EmptyStateWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
